import styled from '@emotion/styled';
import { Variables } from '../../base';

export const Container = styled.div`
    width: 100%;
    background-color: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.n15};
    border-radius: ${Variables.Rounded.small};
    margin: 12px 0;
`;

export const TabContent = styled.div`
    padding: 16px;
`;

export const EntityTypeSelectorContainer = styled.div`
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${Variables.Colors.n15};
`;

export const EntityTypeSelectorLabel = styled.label`
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: ${Variables.Colors.n85};
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const SearchSection = styled.div`
    margin-bottom: 16px;
`;

export const SummarySection = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 12px;
    padding: 8px 0;
`;

export const SummaryLabel = styled.div`
    display: flex;
    gap: 8px;
    align-items: baseline;
`;

export const SummaryLabelTitle = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const SummaryLabelValue = styled.span`
    font-size: 16px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 32px;
    color: ${Variables.Colors.n70};
    font-size: 14px;
`;

export const EmptyMessage = styled.div`
    text-align: center;
    padding: 32px;
    color: ${Variables.Colors.n50};
    font-size: 14px;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    padding: 4px;
`;

export const TableHead = styled.thead`
    background-color: ${Variables.Colors.n5};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    border-bottom: 1px solid ${Variables.Colors.n15};
    
    &:last-child {
        border-bottom: none;
    }
    
    &:hover {
        background-color: ${Variables.Colors.n5};
        
        /* Show action buttons on row hover */
        .actions-container {
            opacity: 1;
        }
    }
`;

export const TableHeader = styled.th`
    padding: 12px;
    text-align: left;
    font-size: 13px;
    font-weight: 600;
    color: ${Variables.Colors.n85};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const TableCell = styled.td`
    padding: 12px;
    font-size: 14px;
    color: ${Variables.Colors.n85};
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s ease;
`;

export const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border: none;
    background-color: transparent;
    color: ${Variables.Colors.n70};
    cursor: pointer;
    border-radius: ${Variables.Rounded.small};
    transition: all 0.2s ease;
    
    &:hover {
        background-color: ${Variables.Colors.n15_16};
        color: ${Variables.Colors.b300};
    }
    
    &:active {
        background-color: ${Variables.Colors.n15_24};
    }
`;

export const TableFooter = styled.div`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${Variables.Colors.n15};
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const PaginationInfo = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const PaginationControls = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

export const PageInfo = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n85};
    font-weight: 500;
`;

export const CopyAllButton = styled.button`
    align-self: flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    color: ${Variables.Colors.b300};
    background-color: transparent;
    border: 1px solid ${Variables.Colors.b300};
    border-radius: ${Variables.Rounded.small};
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 32px;
    min-height: 32px;
    
    &:hover {
        background-color: ${Variables.Colors.b300_l96};
    }
    
    &:active {
        background-color: ${Variables.Colors.b300_l90};
    }
`;

